import { ICaseDecision } from "../../model/CaseDecision";
import { IOrganisation } from "../../../organisations/model/Organisation";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import { DateFormats } from "../../../core/common/Constants";
import moment from "moment";

export interface TCaseDecisionPresentationModel extends ICaseDecision {
  organisationName: string;
  caseDecisionTypeName: string;
  caseDecisionType: IDocumentType;
  formattedDate: string;
}

const CaseDecisionPresentationModel = (
  data: ICaseDecision,
  caseDecisionType?: IDocumentType,
  organisation?: IOrganisation
) => {
  const handler: ProxyHandler<ICaseDecision> = {
    get: function (target, prop, receiver) {
      const decisionDate = target.decisionDate
        ? moment(target.decisionDate)
        : null;
      switch (prop) {
        case "organisationName":
          return organisation?.name;
        case "caseDecisionType":
          return caseDecisionType;
        case "caseDecisionTypeName":
          return caseDecisionType?.name;
        case "formattedDate":
          return decisionDate?.format(DateFormats.DATE) || "";

        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "organisationName":
        case "caseDecisionType":
        case "formattedDate":
        case "caseDecisionTypeName":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<ICaseDecision, TCaseDecisionPresentationModel>(
    data,
    handler
  );
};

export default CaseDecisionPresentationModel;
